<div mat-dialog-title class="week-registration-dialog-shell__title" data-test="dialog">
  <div class="flex flex--row flex--nowrap flex--justify-center">
    <div class="flex--column flex--justify-center">
      @if (data().title; as title) {
        <div class="dialog__title text--bold">
          {{ title | translate }}
        </div>
      }
      @if (data().subTitle; as subTitle) {
        <div class="dialog__subtitle text--small text--gray">
          {{ subTitle | translate }}
        </div>
      }
    </div>
    @if (!data().disableClose) {
      <button
        type="button"
        mat-icon-button
        class="dialog__close flex__child--none"
        data-test="dialog-close"
        (click)="dialogClose.emit()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </div>
</div>

<div mat-dialog-content class="week-registration-dialog-shell__content">
  <ng-content select="[summary]"></ng-content>
  <ng-content select="[content]"></ng-content>
</div>

<div mat-dialog-actions class="week-registration-dialog-shell__actions" data-test="dialogButtons">
  <div class="dialog-actions-wrapper">
    <div class="dialog-actions-group">
      @if (!data().disableClose && data().cancelButton !== false) {
        <button
          type="button"
          mat-button
          data-test="dialog-cancel"
          [disabled]="data().disableCancelButton"
          (click)="dialogClose.emit()"
        >
          {{ data().cancelButtonText }}
        </button>
      }
    </div>

    <div class="dialog-actions-group">
      @if (data().altButton) {
        <button
          type="button"
          mat-button
          data-test="form-dialog-alt"
          [disabled]="data().disableAltButton"
          [color]="data().altButtonColor"
          (click)="alt.emit()"
        >
          {{ data().altButtonText }}
        </button>
      }

      @if (data().confirmButton) {
        <button
          type="submit"
          mat-flat-button
          data-test="dialog-submit"
          [disabled]="data().disableConfirmButton"
          [color]="data().confirmButtonColor"
          (click)="confirm.emit()"
        >
          {{ data().confirmButtonText }}
        </button>
      }
    </div>
  </div>
</div>
